package com.gloopgo.game.ui

actual fun getPlatformActionHints(): PlatformActionHints =
    PlatformActionHints(
        splitSubtitle = "[Space]",
        ejectSubtitle = "[E]",
        showKeyboardPauseHint = true
    )
